<template>
  <div class="pb-2">
    <div
      class="card-servicios__container bg-primary text-white position-relative"
      :class="{ 'collapsed-header': !openDetails || agrupacionesServicios.length === 0 }">
      <button
        v-if="isBorrable"
        class="btn btn-primary bg-transparent border-0 position-absolute top-0 end-0 mt-2 me-2 action-button d-flex align-items-center justify-content-center text-white"
        @click="cerrarCardServicio()">
        <i class="fa-solid fa-xmark icon-centered d-flex align-items-center justify-content-center" />
      </button>

      <div class="d-flex align-items-start justify-content-between">
        <div class="card-servicios__info d-flex flex-column flex-grow-1">
          <span class="mb-10 fs-16 fw-semibold">
            {{ $t('general.persona') }} {{ numeroReserva }}
            <span v-if="!existeCodigoUnirse && numeroPlazas !== null">/ {{ numeroPlazas }}</span>
          </span>
          <template v-if="hasModificarPersona">
            <div v-if="isPrimeraReserva" class="checkbox-container">
              <!-- Mobile-->
              <div class="d-md-none">
                <!-- Fila 1: Checkbox -->
                <div class="d-flex align-items-center mb-10">
                  <input
                    :id="'checkboxSoyYo' + numeroReserva"
                    v-model="reserva.reservaPropia"
                    type="checkbox"
                    class="form-check-input me-2 custom-checkbox" />
                  <label :for="'checkboxSoyYo' + numeroReserva" class="form-check-label fs-13 text-white mb-0">
                    {{ $t('general.esMiReserva') }}
                  </label>
                </div>

                <!-- Fila 2: Nombre y Apellido -->
                <div v-if="reserva.reservaPropia && reserva.usuario.nombre.length > 0" class="mb-10">
                  <span class="text-white fs-16">{{ reserva.usuario.nombre }} {{ reserva.usuario.apellido }}</span>
                </div>

                <!-- Fila 3: Fecha de Nacimiento -->
                <template v-if="reserva.reservaPropia && reserva.usuario.nombre.length > 0 && existsTarifaEdad">
                  <div v-if="!isEditingFechaNacimiento" class="d-flex align-items-center">
                    <CustomIcon :icon="calendarIcon" size="16px" class="text-white me-2" />
                    <span v-if="reserva.usuario.fechaNacimiento" class="text-white fs-16 me-2">
                      {{ fomatDatesHyphen(reserva.usuario.fechaNacimiento) }}
                    </span>
                    <button
                      class="btn btn-primary bg-transparent border-0 p-0 action-button text-white"
                      @click="startEditingFechaNacimiento">
                      <CustomIcon :icon="editIcon" size="12px" />
                    </button>
                  </div>
                  <div v-else class="d-flex align-items-center">
                    <div class="calendar-usuario__container me-2">
                      <Datepicker
                        v-model="tempFechaNacimiento"
                        :format="fomatDatesHyphen"
                        :flow="['year', 'month', 'calendar']"
                        :placeholder="$t('home.form.personalInformation.birthDate')"
                        auto-apply />
                    </div>
                    <span class="text-underline text-white fs-12 p-10 pointer fw-medium" @click="saveFechaNacimiento">
                      {{ $t('botones.guardar') }}
                    </span>
                  </div>
                </template>
              </div>

              <!-- Desktop -->
              <div class="d-none d-md-flex align-items-center mb-10">
                <input
                  :id="'checkboxSoyYoDesktop' + numeroReserva"
                  v-model="reserva.reservaPropia"
                  type="checkbox"
                  class="form-check-input me-2 custom-checkbox" />
                <label
                  :for="'checkboxSoyYoDesktop' + numeroReserva"
                  class="form-check-label fs-13 text-white mb-0 mr-20">
                  {{ $t('general.esMiReserva') }}
                </label>
                <template v-if="reserva.reservaPropia && reserva.usuario.nombre.length > 0">
                  <span class="text-white fs-16 mr-20">
                    {{ reserva.usuario.nombre }} {{ reserva.usuario.apellido }}
                  </span>
                  <template v-if="existsTarifaEdad">
                    <div v-if="!isEditingFechaNacimiento" class="d-flex align-items-center flex-shrink-0">
                      <CustomIcon :icon="calendarIcon" size="16px" class="text-white me-2" />
                      <span v-if="reserva.usuario.fechaNacimiento" class="text-white fs-16 me-2">
                        {{ fomatDatesHyphen(reserva.usuario.fechaNacimiento) }}
                      </span>
                      <button
                        class="btn btn-primary bg-transparent border-0 p-0 action-button text-white me-2"
                        @click="startEditingFechaNacimiento">
                        <CustomIcon :icon="editIcon" size="12px" />
                      </button>
                    </div>
                    <div v-else class="d-flex align-items-center flex-shrink-0">
                      <div class="calendar-usuario__container me-2">
                        <Datepicker
                          v-model="tempFechaNacimiento"
                          :format="fomatDatesHyphen"
                          :flow="['year', 'month', 'calendar']"
                          :placeholder="$t('home.form.personalInformation.birthDate')"
                          auto-apply />
                      </div>
                      <span class="text-underline text-white fs-12 p-10 pointer fw-medium" @click="saveFechaNacimiento">
                        {{ $t('botones.guardar') }}
                      </span>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </template>

          <div v-if="!reserva.reservaPropia && hasModificarPersona">
            <div class="card-servicios__inputs-row">
              <!-- Desktop -->
              <div class="row d-none d-md-flex">
                <div class="col-6 pe-2">
                  <input
                    v-model="reserva.usuario.nombre"
                    type="text"
                    :placeholder="$t('input.field.nombre')"
                    class="form-control text-start placeholder-start fs-16 custom-input-height" />
                </div>
                <div class="col-6 ps-2">
                  <input
                    v-model="reserva.usuario.apellido"
                    type="text"
                    :placeholder="$t('input.field.apellido')"
                    class="form-control text-start placeholder-start fs-16 custom-input-height" />
                </div>
              </div>

              <!-- Mobile -->
              <div class="d-md-none">
                <div class="mb-2">
                  <input
                    v-model="reserva.usuario.nombre"
                    type="text"
                    :placeholder="$t('input.field.nombre')"
                    class="form-control text-start placeholder-start fs-16 custom-input-height" />
                </div>
                <div>
                  <input
                    v-model="reserva.usuario.apellido"
                    type="text"
                    :placeholder="$t('input.field.apellido')"
                    class="form-control text-start placeholder-start fs-16 custom-input-height" />
                </div>
              </div>
            </div>

            <div v-if="existsTarifaEdad" class="row">
              <div class="mt-2 col-12 col-md-6 pe-md-2">
                <Datepicker
                  v-model="tempFechaNacimiento"
                  :format="fomatDatesHyphen"
                  :flow="['year', 'month', 'calendar']"
                  :disabled="!hasModificarPersona"
                  :placeholder="$t('home.form.personalInformation.birthDate')"
                  auto-apply
                  @update:model-value="saveFechaNacimiento()" />
              </div>
            </div>
          </div>
        </div>

        <button
          v-if="filteredAgrupacionesServicios.length > 0"
          class="btn btn-primary bg-transparent border-0 action-button desplegar-button text-white ml-15 mt-20"
          @click="toggleOpenDetails">
          <CustomIcon :icon="openDetails ? arrowUpIcon : arrowDownIcon" size="24px" />
        </button>
      </div>
    </div>
    <div
      v-if="filteredAgrupacionesServicios.length > 0"
      class="card mx-0 p-15 selector-servicios"
      :class="[openDetails ? '' : 'd-none', !openDetails ? 'collapsed-card' : '']">
      <template v-for="agrupacionServicios in filteredAgrupacionesServicios" :key="agrupacionServicios.id">
        <div class="row">
          <ReservaServiciosSeleccion
            :agrupacion-servicios="agrupacionServicios"
            :idx-reserva="idxReserva"
            :disabled-all-servicios="shouldDisableAllServicios" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
  import { computed, nextTick, onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import ReservaServiciosSeleccion from './ReservaServiciosSeleccion.vue';
  import Datepicker from '@vuepic/vue-datepicker';
  import { useUserStore } from '@/store_pinia/userStore';
  import CustomIcon from '@/components/CustomIcon.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import calendarIcon from '@/assets/icons/calendar.svg';
  import editIcon from '@/assets/icons/edit.svg';
  import { calcularEdad, fomatDatesHyphen } from '@/helpers/dateUtiles';
  import { alertWarning } from '@/services/utils/AlertUtils';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { QUIEN_PAGA, TIPOS_PAGO } from '@/constants/viajeConstants';

  const props = defineProps({
    idxReserva: {
      type: Number,
      default: null,
    },
    numeroPlazas: {
      type: Number,
      default: null,
    },
    agrupacionesServicios: {
      type: Array, // VGAgrupacionServiciosDTO[]
      default: () => [],
    },
    hasModificarPersona: {
      type: Boolean,
      default: () => true,
    },
    openDetails: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(['close', 'toggleOpenDetails', 'servicioSeleccionado', 'serviciosDisabled']);

  // todo -> remove this, a component should be route agnostic. All needed should be pass as parameter
  const route = useRoute();
  const userStore = useUserStore();
  const storeHabitacion = informacionHabitacion();
  const { t } = useI18n();

  const reserva = computed(() => storeHabitacion.getReservaByIdx(props.idxReserva));

  const isSinPago = computed(
    () =>
      storeHabitacion.getViaje.tipoPago === TIPOS_PAGO.SIN_PAGO ||
      storeHabitacion.getViaje.quienPaga === QUIEN_PAGA.QUIEN_PAGA_UNICO_PAGADOR
  );
  const numeroReserva = computed(() => props.idxReserva + 1);
  const isPrimeraReserva = computed(() => numeroReserva.value === 1);
  const existeCodigoUnirse = route.query.codigo;
  const isBorrable = computed(() => !isSinPago.value && !isPrimeraReserva.value);
  const existsTarifaEdad = computed(() => storeHabitacion.hasTarifaEdad);
  const hasViajeAlojamiento = computed(() => storeHabitacion.getAlojamiento);
  const edadUsuario = computed(() => {
    const fechaNacimiento = reserva.value?.usuario?.fechaNacimiento;
    return fechaNacimiento ? calcularEdad(fechaNacimiento) : null;
  });

  const isEditingFechaNacimiento = ref(false);
  const tempFechaNacimiento = ref(null);

  function hasServiciosSeleccionables(servicios) {
    return servicios.some(servicio => {
      return (
        !servicio.nulo &&
        (servicio.activo ||
          Object.values(reserva.value.serviciosWithCantidad).some(swc => swc.servicio.id === servicio.id))
      );
    });
  }

  const shouldDisableAllServicios = computed(() => {
    return existsTarifaEdad.value && edadUsuario.value === null;
  });

  const hasConflictoEdad = computed(() => {
    if (!existsTarifaEdad.value || edadUsuario.value === null) {
      return false;
    }

    return (
      props.agrupacionesServicios.filter(agrupacion => agrupacion.paqueteBasico).length !==
      storeHabitacion.getAgrupacionesServicios.filter(agrupacion => agrupacion.paqueteBasico).length ||
      (
        hasViajeAlojamiento.value &&
        !storeHabitacion.getAlojamiento?.habitacion.precios
          .some(precio => precio.minEdad <= edadUsuario.value && edadUsuario.value <= precio.maxEdad)
      )
    );
  });

  const filteredAgrupacionesServicios = computed(() => {
    if (hasConflictoEdad.value) {
      return [];
    }

    return props.agrupacionesServicios.filter(agrupacion => hasServiciosSeleccionables(agrupacion.servicios));
  });

  async function refreshUsuario(forceChange) {
    if (!reserva.value.reservaPropia && forceChange) {
      reserva.value.usuario.nombre = '';
      reserva.value.usuario.apellido = '';
      reserva.value.usuario.fechaNacimiento = null;
      tempFechaNacimiento.value = null;
    } else if (reserva.value.reservaPropia) {
      if (userStore.isLogged) {
        reserva.value.usuario.nombre = userStore.getUsuario.nombre;
        reserva.value.usuario.apellido = userStore.getUsuario.apellidos.split(' ')[0];
        reserva.value.usuario.fechaNacimiento = userStore.getUsuario.fechaNacimiento;
        tempFechaNacimiento.value = reserva.value.usuario.fechaNacimiento;
      } else {
        reserva.value.usuario.nombre = '';
        reserva.value.usuario.apellido = '';
        reserva.value.usuario.fechaNacimiento = null;
        tempFechaNacimiento.value = null;
      }
    }
    nextTick(() => checkConflictsTarifaEdad());
  }

  function cerrarCardServicio() {
    emits('close');
  }

  function toggleOpenDetails() {
    emits('toggleOpenDetails');
  }

  function checkConflictsTarifaEdad() {
    const isDisabled = shouldDisableAllServicios.value || hasConflictoEdad.value;
    emits('serviciosDisabled', isDisabled);

    if (hasConflictoEdad.value) {
      reserva.value.hasConflictoEdad = true;
      deselectAllServicios();
      alertWarning(t('servicios.sinServicioValidoEdad'));
    } else {
      reserva.value.hasConflictoEdad = false;
    }
  }

  function deselectAllServicios() {
    Object.values(reserva.value.serviciosWithCantidad).forEach(swc => {
      if (swc.servicio && !swc.servicio.nulo) {
        storeHabitacion.incrementCupoServicios(swc.servicio, swc.cantidad);
      }
    });
    reserva.value.serviciosWithCantidad = [];
  }

  function startEditingFechaNacimiento() {
    tempFechaNacimiento.value = reserva.value.usuario.fechaNacimiento;
    isEditingFechaNacimiento.value = true;
  }

  function saveFechaNacimiento() {
    const fecha = tempFechaNacimiento.value;
    const fechaFormateada = fecha instanceof Date ? moment(fecha).format('YYYY-MM-DD') : fecha;
    reserva.value.usuario.fechaNacimiento = fechaFormateada;
    if (reserva.value.reservaPropia && userStore.isLogged) {
      userStore.getUsuario.fechaNacimiento = fechaFormateada;
    }
    isEditingFechaNacimiento.value = false;
    nextTick(() => {
      checkConflictsTarifaEdad();
    });
  }

  watch(
    () => reserva.value.reservaPropia,
    () => {
      refreshUsuario(true);
    }
  );

  watch(
    () => userStore.isLogged,
    () => {
      refreshUsuario(false);
    }
  );

  onMounted(async () => {
    await refreshUsuario(false);
    tempFechaNacimiento.value = reserva.value.usuario.fechaNacimiento;
    checkConflictsTarifaEdad();
  });
</script>

<style lang="scss" scoped>
  .text-primary {
    @media (max-width: 768px) {
      font-size: 13px;
    }
    font-size: 13px;
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .form-check-input:checked {
    background-color: var(--bs-secondary);
    border-color: var(--bs-secondary);
  }

  .form-check-input {
    border-radius: 2px;
  }

  body:not(:has(.selector-servicios .reserva-servicios-seleccion)) .desplegar-button {
    display: none !important;
  }

  .action-button {
    padding: 0px;
    padding-right: 8px;
    box-shadow: none !important;
    border: none !important;

    &:focus,
    &:active,
    &:hover {
      box-shadow: none !important;
      border: none !important;
    }
  }

  .icon-centered {
    width: 24px;
    height: 24px;
    font-size: 16px;
  }

  .card-servicios {
    &__container {
      padding: 15px 20px;
      border-top-left-radius: var(--bs-border-radius-xl) !important;
      border-top-right-radius: var(--bs-border-radius-xl) !important;
      background: var(--bs-primary);

      @media (max-width: 768px) {
        font-size: 13px;
      }

      &:not(:has(+ .selector-servicios .reserva-servicios-seleccion)) {
        border-bottom-left-radius: var(--bs-border-radius-xl) !important;
        border-bottom-right-radius: var(--bs-border-radius-xl) !important;
      }

      &.collapsed-header {
        border-bottom-left-radius: var(--bs-border-radius-xl) !important;
        border-bottom-right-radius: var(--bs-border-radius-xl) !important;
      }
    }

    &__actions {
      margin-left: 15px;
    }

    .custom-checkbox {
      width: 15px !important;
      height: 15px !important;
      border-radius: 2px !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      flex-shrink: 0;
    }

    .checkbox-container {
      min-height: auto;

      .form-check-input {
        margin-top: 0 !important;
        vertical-align: middle;
      }

      .form-check-label {
        line-height: 15px !important;
        padding-top: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }

  .selector-servicios {
    display: none;

    &:has(.reserva-servicios-seleccion) {
      display: block;
    }

    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: var(--bs-border-radius-xl);
    border-bottom-right-radius: var(--bs-border-radius-xl);

    @media (max-width: 768px) {
      padding: 10px;
    }
  }

  .calendar-usuario__container {
    padding-right: 8px !important;
    width: 200px !important;
    :deep(.dp__input) {
      height: 35px !important;
    }
  }

  .placeholder-start::placeholder {
    text-align: left !important;
  }

  .custom-input-height {
    height: 35px !important;
  }
</style>
